import React from 'react';
import { FormattedMessage } from 'react-intl';
import { PorletHeaderTitle } from 'components/porletHeader';

/**
 * Vista Previa wrapper + image. Parent should import its `./previewer.scss` (`.film-previewer`, `.img-previewer`).
 *
 * @param {string} src — typically from `preview/sheetImageSrc` (`getDinocSheetPreviewSrc`, `getFasaraViewSheetImgSrc`, etc.).
 */
export default function FilmCatalogPreview({
  src,
  alt = '',
  imgClassName = 'img-previewer',
  children,
}) {
  return (
    <div className="film-previewer">
      <PorletHeaderTitle variant="h7">
        <FormattedMessage id="Vista Previa" />
      </PorletHeaderTitle>
      <img className={imgClassName} src={src} alt={alt} />
      {children}
    </div>
  );
}
